import { onAuthStateChanged, User } from "firebase/auth";
import { useEffect } from "react";

import { getFirebaseAuth as getAuth } from "../";
import { logAnalyticsAuthFailure, logAnalyticsAuthSuccess } from "./events";

export default function useLogAnalyticsOnFirebaseAuthChange() {
  useEffect(
    () =>
      onAuthStateChanged(getAuth(), (user: User | null) => {
        if (user)
          logAnalyticsAuthSuccess({
            providerUserId: user?.providerData[0]?.uid
          });
        if (!user) logAnalyticsAuthFailure();
      }),
    []
  );
}
